import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TopNavBar from "../../layouts/topNavBar";
import SideNavBar from "../../layouts/sideNavBar";
import { ToastContainer, toast } from "react-toastify";
import DashboardSidebar from "./dashboardSidebar";
export default function DocumentPrivacy() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [issuerCard, setIssuerCard] = useState("");
  const [holderCard, setHolderCard] = useState("");
  const handleSelected = (selectedCard) => {
    if (selectedCard === "Issuer") {
      setIssuerCard(selectedCard);
      setHolderCard("");
    } else {
      setHolderCard(selectedCard);
      setIssuerCard("");
    }
  };
  const handleNext = () => {
    const data1 = {
      ...state.data,
      card: issuerCard? issuerCard : holderCard
    }
    if(issuerCard !== "" || holderCard !== "" ){
      issuerCard ?  navigate("/issuer", {state: {data1}}) : navigate("/document-preview", {state: {data1}})
    }else{
      toast.error("Please select one card", {
        autoClose: 1000,
      })
    }
  };
  
  return (
    <main className="page-layout page-layout--dashboard">
      <TopNavBar />
      <article className="w-100 px-0 content-layout">
        <div className="content-layout__inner">
          <SideNavBar />
          <section className="mt-0 body-profile2">
            <div className="mt-0 body-context">
              <div className="inner-sec">
                <div className="body-content">
                  <div className="heading-wrapper mb-5">
                    <div className="fz14 fw500 text-start step-number-text">
                      Step 2
                    </div>
                    <h3 className="p-title font-secondary primaryDarkText">
                      set your document privacy
                    </h3>
                    <span className="fw400 fz16 grayText p-details">
                      Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                      sed diam nonummy nibh euismod tincidunt ut.
                    </span>
                  </div>
                  <h3 className="fz16 fw600 font-secondary text-center">
                    Tell us about yourself!
                  </h3>
                  <div className="mt-4 main-cards-container">
                    <div className="cards-wrapper">
                      <div
                        className={`cards clickable-cards ${
                          issuerCard !== "" ? "selected-card" : ""
                        }`}
                      >
                        <a onClick={() => handleSelected("Issuer")}>
                          <div className="cards-img-wrapper">
                            <div className="selected-tag fz10 fw600">
                              Selected
                            </div>
                            {/* <img src="/images/individual-img.svg" alt="" /> */}
                            <img
                              src="/images/illustrations/issuer-illustration.svg"
                              alt="issuer-img"
                            />
                          </div>
                          <div className="cards-context">
                            <h6 className="cards-heading">
                              {/* <img
                                src="/images/icons/icon-doubletick-selected.svg"
                                alt="icon-doubletick-selected.svg"
                              /> */}
                              Issuer
                            </h6>
                            <p className="cards-details">
                              I’m the only one who will use docurs for personal
                              assistance and sharing
                            </p>
                          </div>
                        </a>
                      </div>
                      <div
                        className={`cards clickable-cards ${
                          holderCard !== "" ? "selected-card" : ""
                        }`}
                      >
                        <a onClick={() => handleSelected("Holder")}>
                          <div className="cards-img-wrapper">
                            <div className="selected-tag fz10 fw600">
                              Selected
                            </div>
                            {/* <img src="/images/organization.svg" alt="" /> */}
                            <img
                              src="/images/illustrations/holder-illustration.svg"
                              alt="holder-img"
                            />
                          </div>
                          <div className="cards-context">
                            <h6 className="cards-heading">
                              {/* <img
                                src="/images/icons/icon-doubletick-selected.svg"
                                alt="icon-doubletick-selected.svg"
                              /> */}
                              Holder
                            </h6>
                            <p className="cards-details">
                              I’m the only one who will use docurs for personal
                              assistance and sharing
                            </p>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <DashboardSidebar handleNext={handleNext}/>
              </div>
            </div>
          </section>
        </div>
      </article>
      <ToastContainer />
    </main>
  );
}
